import { useCallback, useMemo } from "react";
import { Box, Grid, LinearProgress, Table, TableBody, Paper, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { formatWholePercentage } from "utils";

interface IPropsCustomersVisitControl {
	dataReport: any[];
	details?: any;
}
const CustomersVisitControl = (props: IPropsCustomersVisitControl) => {
	const { dataReport, details } = props;
	const {
		totalOrdersPlaced,
		totalVisitsRegistered,
		totalCostumerVisits,
		totalCosutmerPending,
		totalClients,
		totalAverageVisits,
		totalEffectivite
	} = useMemo(() => {
		return dataReport.reduce((acc, curr) => {
			const orders = Number(curr.totalOrders) || 0;
			const visits = curr.totalVisits !== undefined ? Number(curr.totalVisits) : (Number(curr.visitClient) || 0);
			const clientsVisited = Number(curr.visitClient) || 0;
			const assigned = Number(curr.allsClients) || 0;

			acc.totalOrdersPlaced += orders;
			acc.totalVisitsRegistered += visits;
			acc.totalCostumerVisits += clientsVisited;
			acc.totalCosutmerPending += (assigned - clientsVisited);
			acc.totalClients += assigned;
			acc.totalAverageVisits += Number(curr.averageOrdersPerDay) || 0;
			acc.totalEffectivite += Number(curr.visitEffectiveness) || 0;
			return acc;
		}, { 
			totalOrdersPlaced: 0, 
			totalVisitsRegistered: 0, 
			totalCostumerVisits: 0, 
			totalCosutmerPending: 0, 
			totalClients: 0, 
			totalAverageVisits: 0, 
			totalEffectivite: 0 
		});
	}, [dataReport])

	// const { clientsVisit, allsClients } = useMemo(() => {
	// 	return dataReport.reduce((acc, curr) => {
	// 		acc.clientsVisit += curr.visitClient;
	// 		acc.allsClients += curr.allsClients;
	// 		return acc;
	// 	}, { clientsVisit: 0, allsClients: 0 });
	// }, [dataReport]);

	// const getVisitPercentage = useCallback((allsClients: number, clientsVisit: number) => {
	// 	if (allsClients === 0) return 0;
	// 	return ((clientsVisit / allsClients) * 100).toFixed(2);
	// }, []);

	const getIdealAvance = useMemo(() => {
		return Math.round((details?.dayWorked / details?.totalDays) * 100);
	}, [details])

	const formateValued = useCallback((value: number) => {
		return value.toFixed(2);
	}, []);

	const getColor = useCallback((percentage: number) => {
		if (percentage >= getIdealAvance) return "#4caf50";
		return "#f55a4fff";
//		if (percentage >= 75) return "#4caf50";
//		if (percentage >= 40) return "#ff9800";
	}, [getIdealAvance]);

	return (
		<>
			<Grid container spacing={2} mb={2} px={2}>
				<Grid size={12} mb={2}>
					<Typography variant="h6" fontWeight="bold">
						Control de Visitas de Clientes por Vendedor
					</Typography>
				</Grid>
				<Grid size={4}>
					<Paper elevation={3} sx={{ padding: 2, mb: 2, backgroundColor: "#f5f5f5", display: 'flex', alignItems: 'center', gap: 2 }}>
						{/* <StorefrontIcon sx={{ fontSize: 40, color: "#183555" }} /> */}
						<Box>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#183555" }}>
								Dias transcurridos
							</Typography>
							<Typography variant="h4" fontWeight="bold" sx={{ color: "#183555" }}>{details?.dayWorked}</Typography>
						</Box>
					</Paper>
				</Grid>
				<Grid size={4}>
					<Paper elevation={3} sx={{ padding: 2, mb: 2, backgroundColor: "#f5f5f5", display: 'flex', alignItems: 'center', gap: 2 }}>
						{/* <GradingIcon sx={{ fontSize: 40, color: "#183555" }} /> */}
						<Box>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#183555" }}>
								Dias habiles
							</Typography>
							<Typography variant="h4" fontWeight="bold" sx={{ color: "#183555" }}>{details?.totalDays}</Typography>
						</Box>
					</Paper>
				</Grid>
				<Grid size={4}>
					<Paper elevation={3} sx={{ padding: 2, mb: 2, backgroundColor: "#f5f5f5", display: 'flex', alignItems: 'center', gap: 2 }}>
						{/* <PercentIcon sx={{ fontSize: 40, color: "#183555" }} /> */}
						<Box>
							<Typography variant="subtitle1" fontWeight="bold" sx={{ color: "#183555" }}>
								Avance ideal
							</Typography>
							<Typography variant="h4" fontWeight="bold" sx={{ color: "#183555" }}>{getIdealAvance}%</Typography>
						</Box>
					</Paper>
				</Grid>
			</Grid>
			<TableContainer sx={{ minHeight: 600, px: 2, maxHeight: "63vh" }}>
				<Table sx={{ minWidth: 650 }} aria-label="simple table" stickyHeader>
					<TableHead>
						<TableRow sx={{ backgroundColor: "#183555" }}>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Ruta</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Vendedor</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Pedidos realizados</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Visitas registradas</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Promedio de visitas</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Clientes Visitados</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Clientes Asignados</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography sx={{ color: "#183555" }} fontWeight="bold">Clientes Pendientes</Typography>
							</TableCell>
							<TableCell>
								<Typography sx={{ color: "#183555" }} fontWeight="bold">% Efectividad de visitas</Typography>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{
							dataReport.map((order, index) => {
								const visitsCount = order.totalVisits !== undefined ? order.totalVisits : (order.visitClient ?? 0);
								return (
									<TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: "#f5f5f5" } }}>
										<TableCell>{order.router}</TableCell>
										<TableCell>
											<Typography variant="body2" fontWeight="bold">{order.vendorName}</Typography>
											<Typography variant="caption" color="text.secondary">{order.email}</Typography>
										</TableCell>
										<TableCell align="center">{order.totalOrders ?? 0}</TableCell>
										<TableCell align="center">{visitsCount}</TableCell>
										<TableCell align="center">{formateValued(order.averageOrdersPerDay ?? 0)}</TableCell>
										<TableCell align="center">{order.visitClient ?? 0}</TableCell>
										<TableCell align="center">{order.allsClients ?? 0}</TableCell>
										<TableCell align="center">{(order.allsClients ?? 0) - (order.visitClient ?? 0)}</TableCell>
										<TableCell>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' }}>
												<LinearProgress
													variant="determinate"
													value={formatWholePercentage(order.visitEffectiveness)}
													sx={{
														flex: 1,
														minWidth: 100,
														backgroundColor: "#e0e0e0",
														"& .MuiLinearProgress-bar": {
															backgroundColor: getColor(formatWholePercentage(order.visitEffectiveness)),
														}
													}}
												/>
												<Typography fontWeight="bold" sx={{ color: getColor(formatWholePercentage(order.visitEffectiveness)), minWidth: 50, textAlign: 'right' }}>
													{formatWholePercentage(order.visitEffectiveness)}%
												</Typography>
											</Box>
										</TableCell>
									</TableRow>
								)
							})
						}
						<TableRow sx={{ backgroundColor: "#f4f4f4", position: "sticky", bottom: 0 }}>
							<TableCell colSpan={2}>
								<Typography fontWeight="bold">Totales</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography fontWeight="bold">{totalOrdersPlaced}</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography fontWeight="bold">{totalVisitsRegistered}</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography fontWeight="bold">{formateValued(totalAverageVisits)}</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography fontWeight="bold">{totalCostumerVisits}</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography fontWeight="bold">{totalClients}</Typography>
							</TableCell>
							<TableCell align="center">
								<Typography fontWeight="bold">{totalCosutmerPending}</Typography>
							</TableCell>
							<TableCell>
								<Typography fontWeight="bold">{dataReport.length > 0 ? formatWholePercentage(totalEffectivite / dataReport.length) : 0}%</Typography>
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};
export default CustomersVisitControl;